<div class="container">
  <div class="row">
    <div class="login-cont mx-auto">
      <div class="card login-form">
        <div class="card-header">Login</div>
        <div class="card-body">
          <form (ngSubmit)="login(loginForm)" #loginForm="ngForm">
            <div class="form-group">
              <label for="exampleInputEmail1">Username</label>
              <input
                type="text"
                class="form-control"
                required
                [(ngModel)]="loginData.username"
                name="username"
                #username="ngModel"
                id="user-login-username"
                placeholder="Username"
                [readonly]="loading"
              />
              <div class="inp-error" *ngIf="(username.dirty || username.touched) && !username.valid">Username is invalid.</div>
            </div>
            <div class="form-group">
              <label for="exampleInputPassword1">Password</label>
              <input
                type="password"
                class="form-control auth-inp"
                id="name"
                [(ngModel)]="loginData.password"
                name="password"
                #password="ngModel"
                id="user-login-password"
                placeholder="Password"
                [readonly]="loading"
                required
              />
              <div class="inp-error" *ngIf="(password.dirty || password.touched) && !password.valid">Password is invalid.</div>
            </div>
            <div class="form-group" *ngIf='showTotp'>
              <label for="totp">2FA code</label>
              <input
                type="number"
                class="form-control"
                [(ngModel)]="loginData.totp"
                name="totp"
                #totp="ngModel"
                id="user-login-totp"
                [readonly]="loading"
              />
              <div class="inp-error" *ngIf="(totp.dirty || totp.touched) && !totp.valid">2FA code is invalid.</div>
            </div>
            <button id='loginSubmit' class="btn btn-primary btn-block btn-lg mt-2" type="submit" [disabled]="loading">Submit</button>
            <p class="text-center mt-2"><a id='loginForgottenPassword' href="#" (click)="forgottenPassword()">Forgotten your password?</a></p>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/auth/login/login.component.html